import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import TowerEffect from "@/Components/TowerEffect/hyTower"; // 已迁移的塔板热力图组件
import Charts from "./chartHtml"; // 已迁移的图表组件
import { hyInputs, hyParamsMap } from "./hyInput";
// import CalPythonModule from "@services/PythonModule";
// import theme from "@theme";
import tempHyResult from "./tempData";
import { getJob,hydraulics } from "@/services/common";
import userInfo from "@/Components/user";
import { Spin, message, Modal } from "antd";

// 引入 Less 样式
import "./hydraulics.less";

// 流量单位选项
const units = [
  { id: "kg/h", label: "kg/h", value: "kg/h", color: "#007cdc" },
  { id: "m3/h", label: "m³/h", value: "m3/h", color: "#007cdc" },
  { id: "m3/s", label: "m³/s", value: "m3/s", color: "#007cdc" },
];

const HydraulicsComponent = (props: any) => {
  const { results, inputs, scrollViewRef } = props;
  const sectionPositions = useRef<Record<string, number>>({});
  const [curTrayNo, setCurTrayNo] = useState<number>(0);
  const [calInputs, setCalInputs] = useState<any>(null);
  const [hyResult, setHyResult] = useState<any>(null);
  const [modalStatus, setModalStatus] = useState<boolean>(false);
  const [paramListStatus, setParamListStatus] = useState<boolean>(false);
  const [unit, setUnit] = useState<string>("kg/h");
  const [hyFilePath, setHyFilePath] = useState<string>("");
  const [hyPolling, setHyPolling] = useState<boolean>(false);
  const [hyError, setHyError] = useState<string>("");
  const params = useParams();
  const flowId = params.f;
  console.log("flowId:",flowId);
  
  // 初始化塔板编号
  useEffect(() => {
    setCurTrayNo(0);
  }, [results, inputs]);

useEffect(() => {
  if (!results || !inputs) return;

  const newInputs = {
    device_config: {
      ...hyInputs.device_config,
      D: inputs.params.D_col,
      // A_d_ratio: Number(
      //   (1.22 / ((Math.PI * inputs.params.D_col * inputs.params.D_col) / 4)).toFixed(4)
      // ),
      phi_hole: Number(
        (1.02 / ((Math.PI * inputs.params.D_col * inputs.params.D_col) / 4)).toFixed(4)
      ),
      d_o: inputs.params.d_hole,
    },
    stream_config: {
      ...hyInputs.stream_config,
      L_op: results.result.L_kg_per_h[curTrayNo],
      V_op: results.result.V_kg_per_h[curTrayNo],
      rhoL_op: results.result.rho_L[curTrayNo],
      rhoV_op: results.result.rho_V[curTrayNo],
      sigma_op: results.result.sigma[curTrayNo],
    },
  };
  setCalInputs(newInputs);console.log('newInputs', newInputs);

  let isCanceled = false; // 防竞态标记

 const fetchHydraulics = async () => {
  try {
    const hydraulicsRes = await hydraulics(newInputs, userInfo.access_token);
    console.log('hydraulicsRes', hydraulicsRes.status);
    setHyResult({
        status:hydraulicsRes.status,
        result: hydraulicsRes.data,
      });
      
    if (hydraulicsRes.status !== 200 || !hydraulicsRes.data?.id) {
      console.log('hydraulicsRes', hydraulicsRes);
      setHyError("水力学计算启动失败");
      return;
    }
  } catch (err) {
    console.error("水力学计算异常：", err);

    // ===================== 只改这里 =====================
    let errMsg = "接口请求失败，请重试";
    if (err.response) {
      const { status, data } = err.response;
      console.log('错误状态码:', status);
      console.log('具体校验错误:', data?.detail);

      // 解析后端英文错误 → 转中文
      if (data?.detail && Array.isArray(data.detail)) {
        errMsg = data.detail.map(item => {
          // 取出最后一个字段名 sigma_op
          const field = item.loc?.[item.loc.length - 1] || "参数";
          
          // 错误英文转中文
          let msg = item.msg;
          if (msg.includes("valid number")) msg = "请输入有效数字";
          if (msg.includes("field required")) msg = "不能为空";

          return `${field}：${msg}`;
        }).join("；");
      }
    }
    // 弹窗提示（用你项目里的 message 即可）
    Modal.error({
      title: '参数校验失败',
      content: errMsg,
    });

    if (!isCanceled) {
      setHyError(errMsg);
      // setHyError("接口请求失败，请重试");
    }
  }
};
  fetchHydraulics();

  // 清理函数：防止组件卸载后 setState 造成内存泄漏
  return () => {
    isCanceled = true;
  };
}, [results, curTrayNo, inputs]);

  /******************* 保留原有计算逻辑（不要删除） **********************************/
  // useEffect(() => {
  //   let interval: any;
  //   if (hyPolling && hyFilePath) {
  //     interval = setInterval(async () => {
  //       try {
  //         const content = await CalPythonModule.readFile(hyFilePath);
  //         try {
  //           const data = JSON.parse(content);
  //           if (data.status === "completed") {
  //             console.log("data", data);
  //             setHyResult(data);
  //             setHyPolling(false);
  //           } else if (data.status === "error") {
  //             setHyError(data.message);
  //             setHyPolling(false);
  //           } else {
  //             setHyResult(data);
  //           }
  //         } catch (e) {
  //           console.log("Hydraulics parse error:", e);
  //           setHyResult(content);
  //         }
  //       } catch (e) {
  //         console.error("Hydraulics polling error:", e);
  //       }
  //     }, 1000);
  //   }
  //   return () => clearInterval(interval);
  // }, [hyPolling, hyFilePath]);

  // const handleCalculateHydraulics = async (c_inputs: any) => {
  //   setHyError("");
  //   setHyPolling(true);
  //   setHyResult(null);
  //   try {
  //     const path = await CalPythonModule.calculateHydraulics(
  //       JSON.stringify(c_inputs.device_config),
  //       JSON.stringify(c_inputs.stream_config),
  //     );
  //     setHyFilePath(path);
  //   } catch (e: any) {
  //     console.error("Hydraulics calculation failed to start:", e);
  //   }
  // };
  /******************* 保留原有计算逻辑结束 **********************************/

  // 滚动相关方法（适配Web端滚动）
  const scrollto = () => {
    handleScrollTo("inputArea");
  };

  const scrolltoChart = () => {
    const yPosition = sectionPositions.current["inputArea"] || 0;
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTop = yPosition + 600;
    }
  };

  const handleScrollTo = (sectionId: string) => {
    const yPosition = sectionPositions.current[sectionId] || 0;
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTop = yPosition + 400;
    }
  };

  // 记录元素位置（适配Web端）
  const handleLayout = (sectionId: string, event: React.MouseEvent<HTMLDivElement>) => {
    const y = event.currentTarget.getBoundingClientRect().top;
    sectionPositions.current[sectionId] = y;
  };

  // 渲染输入参数列表
  const showInputParams = () => {
    if (!calInputs) return null;

    return (
      <div className={`inputs-list ${paramListStatus ? "show" : "hide"}`}>
        {Object.keys(calInputs.device_config).map((key) => {
          return (
            <div key={key} className="input-item">
              <div className="input-label-container">
                <span className="input-label">{hyParamsMap[key].label}：</span>
              </div>
              <div className="input-value-container">
                <input
                  type="number"
                  className="input-value"
                  defaultValue={calInputs.device_config[key].toString()}
                  onChange={(e) => {
                    setCalInputs({
                      ...calInputs,
                      device_config: {
                        ...calInputs.device_config,
                        [key]: isNaN(Number(e.target.value)) ? 0 : Number(e.target.value),
                      },
                    });
                  }}
                />
                <span className="input-unit">{hyParamsMap[key].unit}</span>
              </div>
            </div>
          );
        })}
        <div className="input-btn-group">
          <button
            className="sub-button"
            onClick={() => {
              // handleCalculateHydraulics(calInputs); // 保留原有逻辑
              setParamListStatus(false);
              scrolltoChart();
            }}
          >
            <span className="sub-button-text">确定</span>
          </button>
          <button
            className="cancle-button"
            onClick={() => setParamListStatus(false)}
          >
            <span className="cancle-button-text">关闭</span>
          </button>
        </div>
      </div>
    );
  };

  // 渲染计算结果
  const showResults = () => {
    if (hyPolling) {
      return (
        <div className="charts-container loading-container">
          <div className="loading-content">
            {/* 替换为Web端加载动画组件 */}
            <div className="loading-icon"></div>
            <span className="loading-text">计算中..., 请稍候！</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="charts-container">
          {hyResult && hyResult.status === 200 ? (
            <Charts trayNo={curTrayNo} hyResult={hyResult} unit={unit} />
          ) : (
            <div className="error-container">
              <span className="error-text">{hyError || <Spin />}</span>
            </div>
          )}
        </div>
      );
    }
  };

  // 渲染单位选择器（RadioGroup替换为Web端实现）
  const renderUnitSelector = () => {
    return (
      <div className="unit-selector">
        <span className="selected-unit-btn-title">切换流量单位：</span>
        <div className="radio-group">
          {units.map((item) => (
            <label key={item.id} className="radio-label">
              <input
                type="radio"
                name="unit"
                value={item.id}
                checked={unit === item.id}
                onChange={() => setUnit(item.id)}
                className="radio-input"
              />
              <span className="radio-label-text">{item.label}</span>
            </label>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="hydraulics-container">
      {/* 塔板热力图区域 */}
      <div className="tower-effects-container">
        <div className="eff-container">
          <h3 className="eff-title">塔板气相体积流量分布</h3>
          <div className="eff-content">
            <TowerEffect
              currentMode={null}
              currentData={null}
              setCurrentData={null}
              currentModeData={results.result.hydraulics.Q_V}
              wrapWidth={280}
              trayHeight={290}
              imageStyle={{
                height: 400,
                width: 80,
              }}
              trayContainerStyle={{
                top: 40,
                left: 27,
                width: 47,
              }}
              unit="m³/h"
            />
          </div>
        </div>
        <div className="eff-container">
          <h3 className="eff-title">塔板液相体积流量分布</h3>
          <div className="eff-content">
            <TowerEffect
              currentMode={null}
              currentData={null}
              setCurrentData={null}
              currentModeData={results.result.hydraulics.Q_L}
              wrapWidth={280}
              trayHeight={290}
              imageStyle={{
                height: 400,
                width: 80,
              }}
              trayContainerStyle={{
                top: 40,
                left: 27,
                width: 47,
              }}
              unit="m³/h"
            />
          </div>
        </div>
        <div className="eff-container">
          <h3 className="eff-title">塔板压降分布</h3>
          <div className="eff-content">
            <TowerEffect
              currentMode={null}
              currentData={null}
              setCurrentData={null}
              currentModeData={results.result.hydraulics.delta_P_tray.map((i: any) => Number(i))}
              wrapWidth={280}
              trayHeight={290}
              imageStyle={{
                height: 400,
                width: 80,
              }}
              trayContainerStyle={{
                top: 40,
                left: 27,
                width: 47,
              }}
              unit="Pa"
            />
          </div>
        </div>
      </div>

      {/* 计算控制区域 */}
      <div className="cal-container">
        <div className="cal-header">
          <div className="cal-header-left">
            <h3 className="cal-title">塔板性能负荷计算：</h3>
            <div className="selected-tray-container">
              <button
                className="selected-tray-btn"
                onClick={() => setModalStatus(true)}
              >
                <span className="selected-tray-btn-title">切换塔板：</span>
                <span className="selected-tray">{curTrayNo + 1}# 塔板</span>
                <span className="caret-icon">▼</span>
              </button>
            </div>
            {/* 移除横竖屏判断，直接显示单位选择器 */}
            {renderUnitSelector()}
          </div>
          <div className="extra-area">
            <button
              className="setting-btn"
              onClick={() => {
                setParamListStatus(!paramListStatus);
                if (!paramListStatus) {
                  scrollto();
                }
              }}
            >
              <span className="gear-icon">⚙️</span>
              <span className="setting-btn-text">塔板参数</span>
            </button>
          </div>
        </div>

        {/* 输入参数区域 */}
        <div
          ref={(el) => el && handleLayout("inputArea", { currentTarget: el } as any)}
          className="cal-input-container"
        >
          {showInputParams()}
        </div>

        {/* 结果展示区域 */}
        {showResults()}
      </div>

      {/* 塔板选择模态框（替换RN Modal） */}
      {modalStatus && (
        <div className="modal-overlay">
          <div className="modal-wrap">
            <div className="modal-header">
              <h3 className="modal-title">选择塔板：</h3>
              <button
                className="modal-close-btn"
                onClick={() => setModalStatus(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-content">
              {Array.from({ length: inputs.params.N }, (_, i) => i).map((i) => (
                <button
                  key={i}
                  className={`tray-btn ${curTrayNo === i ? "active" : ""}`}
                  onClick={() => {
                    setCurTrayNo(i);
                    setModalStatus(false);
                  }}
                >
                  <span className="tray-btn-text">{`${i + 1}# 塔板`}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HydraulicsComponent;